import { useMemo } from 'react'
import { useGame } from '../contexts/GameContext'
import { Timer } from './Timer'

export function GameHUD() {
	const { gameData, setGameData, currentScreen, changeScreen } = useGame()

	const timeAdded = useMemo(() => {
		return Math.floor(gameData.score / 100) * 30
	}, [gameData.score])

	return (
		<>
			<div className="absolute top-4 left-16 z-10">
				<div
					className="relative h-20 w-64 bg-no-repeat pt-3 lg:h-32 lg:w-80 lg:pt-4"
					style={{
						backgroundImage: `url("./assets/fundo_menu_status_jogo.svg")`,
						backgroundSize: 'contain',
					}}
				>
					<div className="grid w-[90%] grid-cols-3 items-center text-center text-white uppercase">
						<div className="grid">
							<strong className="text-xs">Chances</strong>
							<div className="-space-x-4 flex gap-1">
								{Array.from({ length: gameData.lives }).map((_, i) => (
									<img
										key={i}
										src="./assets/lixo/garrafa_vida.svg"
										alt="Life"
										className="size-8 lg:size-10"
									/>
								))}
							</div>
						</div>

						<Timer
							isActive={currentScreen === 'game'}
							timeAdded={timeAdded}
							onTimeUp={(matchTime) => {
								setGameData((prev) => ({ ...prev, matchTime }))
								changeScreen('timeUp')
							}}
						/>

						<div className="grid">
							<strong className="text-xs">Pontos</strong>
							<span className="text-3xl">{gameData.score}</span>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
